import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { addChannel } from "../../network/api/channels";

const AddChannelPage = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();

  const [formData, setFormData] = useState({
    name: "",
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    addChannel({ name: formData.name }).then((result) => {
      if (result.data.message === "Created successfully") {
        toast.success(result.data.message, {
          position: "top-right",
        });
        props.changeToView("View Channels");
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
      setLoading(false);
    });
  };

  return (
    <div className="add-brokers-guideline">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="Name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter Name"
            required
            onInvalid={(e) => e.target.setCustomValidity("Name is required")}
          />
        </div>

        {loading ? (
          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <div className="spinner"></div>
          </div>
        ) : (
          <button type="submit" className="submit-button">
            Add Channel
          </button>
        )}
      </form>
      <ToastContainer />
    </div>
  );
};

export default AddChannelPage;
